import { USER_EVENT_TYPE } from '@/typings/enums/USER_EVENT_TYPE';
import BaseOrganizationUserEntity from './BaseOrganizationUserEntity';


export default class OrganizationUserEntity extends BaseOrganizationUserEntity<IOrganizationUserDetailModel> {
	get user () { return this.state.user; }
	get roles () { return this.state.user?.roleUsers; }

	get userCreationDate () {
		const event = this.state.user?.userEvents.findByKey(USER_EVENT_TYPE.Created, 'type');
		return event
			? new Date(event.date)
			: undefined;
	}
}
